import { LegalLayout } from "../components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      overline="Informativa"
      title={<>Privacy <span className="italic text-[#D47738]">Policy</span></>}
      updated="Giugno 2026"
      related={[
        { to: "/cookie-policy", label: "Cookie Policy" },
        { to: "/gdpr", label: "Diritti GDPR" },
      ]}
      sections={[
        {
          h: "Titolare del trattamento",
          p: [
            "Il titolare del trattamento dei dati personali è Birrificio Vecchio Cinghiale S.r.l., con sede in Via Giosuè Carducci 12, 20123 Milano (MI), Italia.",
            "Per qualsiasi richiesta relativa alla privacy puoi scrivere a: amministrazione@vecchiocinghiale.beer.",
          ],
        },
        {
          h: "Dati che raccogliamo",
          p: ["Trattiamo i dati personali che ci fornisci al momento dell'acquisto e della navigazione:"],
          list: [
            "Dati anagrafici e di contatto (nome, email, indirizzo di spedizione).",
            "Dati di pagamento, gestiti in modo sicuro dal nostro fornitore Stripe (non conserviamo i dati della carta).",
            "Dati di navigazione e cookie tecnici o statistici.",
          ],
        },
        {
          h: "Finalità del trattamento",
          p: ["I tuoi dati vengono trattati per le seguenti finalità:"],
          list: [
            "Gestione ed evasione degli ordini e delle spedizioni.",
            "Adempimenti fiscali e contabili previsti dalla legge.",
            "Assistenza clienti e risposta alle richieste.",
            "Con il tuo consenso, invio di comunicazioni promozionali.",
          ],
        },
        {
          h: "Base giuridica",
          p: [
            "Il trattamento si fonda sull'esecuzione del contratto di vendita, sull'adempimento di obblighi di legge e, ove previsto, sul consenso liberamente prestato dall'utente.",
          ],
        },
        {
          h: "Conservazione dei dati",
          p: [
            "I dati vengono conservati per il tempo strettamente necessario alle finalità indicate e comunque nel rispetto dei termini di legge (ad esempio 10 anni per i documenti fiscali).",
          ],
        },
        {
          h: "Comunicazione a terzi",
          p: [
            "I dati possono essere comunicati a soggetti che erogano servizi funzionali (corrieri, provider di pagamento come Stripe, servizi di hosting), sempre nel rispetto della normativa vigente. Non cediamo i tuoi dati a terzi per finalità di marketing autonomo.",
          ],
        },
        {
          h: "I tuoi diritti",
          p: [
            "In qualità di interessato puoi esercitare in ogni momento i diritti previsti dagli artt. 15-22 del GDPR. Consulta la pagina dedicata ai diritti GDPR per i dettagli o scrivici a amministrazione@vecchiocinghiale.beer.",
          ],
        },
      ]}
    />
  );
}
